const RETURN_TO_KEY = 'auth.returnTo'

function isUnsafeReturnPathname(pathname) {
  if (!pathname || typeof pathname !== 'string') return true
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return true
  if (pathname === '/login' || pathname.startsWith('/login/')) return true
  if (pathname === '/unauthorized') return true
  return false
}

/** React Router `location` 객체로부터 로그인 후 이동할 경로(쿼리·해시 포함) */
export function postLoginPathFromRouterState(fromLocation) {
  if (!fromLocation || typeof fromLocation.pathname !== 'string') return null
  const pathname = fromLocation.pathname || '/'
  const search = fromLocation.search || ''
  const hash = fromLocation.hash || ''
  if (isUnsafeReturnPathname(pathname)) return null
  return `${pathname}${search}${hash}`
}

/** 전체 페이지 이동 직전, 현재 URL을 로그인 후 복귀용으로 저장 */
export function stashCurrentPathForLoginReturn() {
  try {
    if (typeof window === 'undefined') return
    const { pathname, search, hash } = window.location
    if (isUnsafeReturnPathname(pathname)) return
    sessionStorage.setItem(RETURN_TO_KEY, `${pathname}${search || ''}${hash || ''}`)
  } catch { }
}

/** 저장된 복귀 경로를 읽고 제거. 없거나 유효하지 않으면 null */
export function consumeStashedLoginReturnPath() {
  try {
    const s = sessionStorage.getItem(RETURN_TO_KEY)
    sessionStorage.removeItem(RETURN_TO_KEY)
    if (!s || typeof s !== 'string') return null
    if (!s.startsWith('/') || s.startsWith('//')) return null
    const pathname = s.split(/[?#]/)[0]
    if (isUnsafeReturnPathname(pathname)) return null
    return s
  } catch {
    return null
  }
}

export function clearStashedLoginReturnPath() {
  try {
    sessionStorage.removeItem(RETURN_TO_KEY)
  } catch { }
}
